module.exports = __webpack_public_path__ + "img/icon-descontos.69e1e417.svg";